import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-12 mb-5" }, null, -1)
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_avatar",
  "aria-expanded": "true",
  "aria-controls": "kt_account_avatar"
}, [
  /*#__PURE__*/_createVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createVNode("h3", { class: "fw-bolder m-0" }, "Profile Avatar")
  ])
], -1)
const _hoisted_4 = {
  id: "kt_account_avatar",
  class: "collapse show"
}
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "row mb-6" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Avatar", -1)
const _hoisted_8 = { class: "col-lg-8" }
const _hoisted_9 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true",
  style: {"background-image":"url(media/avatars/blank.png)"}
}
const _hoisted_10 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change avatar"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "bi bi-pencil-fill fs-7" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("input", {
  type: "hidden",
  name: "avatar_remove"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "bi bi-x fs-2" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "form-text" }, "Allowed file types: png, jpg, jpeg.", -1)
const _hoisted_15 = { class: "card mb-5 mb-xl-10" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_profile_details",
  "aria-expanded": "true",
  "aria-controls": "kt_account_profile_details"
}, [
  /*#__PURE__*/_createVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createVNode("h3", { class: "fw-bolder m-0" }, "Profile Details")
  ])
], -1)
const _hoisted_17 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_18 = { class: "card-body border-top p-9" }
const _hoisted_19 = { class: "row mb-6" }
const _hoisted_20 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label  fw-bold fs-6" }, "Full Name", -1)
const _hoisted_21 = { class: "col-lg-8" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-lg-4 fv-row" }
const _hoisted_24 = { class: "col-lg-4 fv-row" }
const _hoisted_25 = { class: "col-lg-4 fv-row" }
const _hoisted_26 = { class: "row mb-6" }
const _hoisted_27 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label  fw-bold fs-6" }, "Gender", -1)
const _hoisted_28 = { class: "col-lg-8 fv-row" }
const _hoisted_29 = /*#__PURE__*/_createVNode("option", { value: "M" }, "Male", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("option", { value: "F" }, "Female", -1)
const _hoisted_31 = { class: "row mb-6" }
const _hoisted_32 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createVNode("span", { class: "" }, "Birthday")
], -1)
const _hoisted_33 = { class: "col-lg-8 fv-row" }
const _hoisted_34 = { class: "row mb-6" }
const _hoisted_35 = {
  key: 0,
  class: "col-lg-4 col-form-label fw-bold fs-6"
}
const _hoisted_36 = {
  key: 1,
  class: "col-lg-4 col-form-label fw-bold fs-6"
}
const _hoisted_37 = { class: "col-lg-8 fv-row" }
const _hoisted_38 = { class: "row mb-6" }
const _hoisted_39 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Address", -1)
const _hoisted_40 = { class: "col-lg-8 fv-row" }
const _hoisted_41 = { class: "row mb-6" }
const _hoisted_42 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createVNode("span", { class: "" }, "Country"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Country of origination"
  })
], -1)
const _hoisted_43 = { class: "col-lg-8 fv-row" }
const _hoisted_44 = /*#__PURE__*/_createVNode("option", { value: "0" }, "Select Country", -1)
const _hoisted_45 = { class: "row mb-6" }
const _hoisted_46 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createVNode("span", { class: "" }, "Region/State"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Region"
  })
], -1)
const _hoisted_47 = { class: "col-lg-8 fv-row" }
const _hoisted_48 = /*#__PURE__*/_createVNode("option", { value: "0" }, "Select Region/State", -1)
const _hoisted_49 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_50 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createVNode("span", { class: "" }, "City/LGA"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Region"
  })
], -1)
const _hoisted_51 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_52 = /*#__PURE__*/_createVNode("option", { value: "0" }, "Select City", -1)
const _hoisted_53 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_54 = { class: "row mb-6" }
const _hoisted_55 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createVNode("span", { class: "" }, "Mobile Number"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Mobile number must be active"
  })
], -1)
const _hoisted_56 = { class: "col-lg-8" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "col-lg-6 fv-row" }
const _hoisted_59 = { class: "row mb-6" }
const _hoisted_60 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createVNode("span", { class: "" }, "Email Address"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Email address must be active"
  })
], -1)
const _hoisted_61 = { class: "col-lg-8" }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-lg-6 fv-row" }
const _hoisted_64 = {
  key: 1,
  class: "row mb-0"
}
const _hoisted_65 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Hide Network Activity", -1)
const _hoisted_66 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_67 = { class: "form-check form-check-solid form-switch fv-row" }
const _hoisted_68 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "btnHideUnhideNetworkActivity"
}, null, -1)
const _hoisted_69 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_70 = /*#__PURE__*/_createVNode("span", { class: "indicator-label" }, " Save Changes ", -1)
const _hoisted_71 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_72 = { class: "card mb-5 mb-xl-10" }
const _hoisted_73 = /*#__PURE__*/_createVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_signin_method"
}, [
  /*#__PURE__*/_createVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createVNode("h3", { class: "fw-boldest m-0" }, "Change Password")
  ])
], -1)
const _hoisted_74 = {
  id: "kt_account_signin_method",
  class: "collapse show"
}
const _hoisted_75 = { class: "card-body border-top p-9" }
const _hoisted_76 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_77 = /*#__PURE__*/_createVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Password", -1)
const _hoisted_78 = /*#__PURE__*/_createVNode("div", { class: "fs-6 fw-bold text-gray-600" }, "************", -1)
const _hoisted_79 = /*#__PURE__*/_createVNode("div", { class: "fs-6 fw-bold text-gray-600 mb-4" }, " Password must be at least 8 characters and contains symbols ", -1)
const _hoisted_80 = { class: "row mb-6" }
const _hoisted_81 = { class: "col-lg-4" }
const _hoisted_82 = { class: "fv-row mb-0" }
const _hoisted_83 = /*#__PURE__*/_createVNode("label", {
  for: "currentpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}, "Current Password", -1)
const _hoisted_84 = { class: "col-lg-4" }
const _hoisted_85 = { class: "fv-row mb-0" }
const _hoisted_86 = /*#__PURE__*/_createVNode("label", {
  for: "newpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}, "New Password", -1)
const _hoisted_87 = { class: "col-lg-4" }
const _hoisted_88 = { class: "fv-row mb-0" }
const _hoisted_89 = /*#__PURE__*/_createVNode("label", {
  for: "confirmpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}, "Confirm New Password", -1)
const _hoisted_90 = { class: "d-flex" }
const _hoisted_91 = /*#__PURE__*/_createVNode("span", { class: "indicator-label" }, " Update Password ", -1)
const _hoisted_92 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_93 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_94 = /*#__PURE__*/_createVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_echeque_method"
}, [
  /*#__PURE__*/_createVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createVNode("h3", { class: "fw-boldest m-0" }, "Generate E-Cheque")
  ])
], -1)
const _hoisted_95 = {
  id: "kt_account_echeque_method",
  class: "collapse show"
}
const _hoisted_96 = { class: "card-body border-top p-9" }
const _hoisted_97 = { class: "row col-md-10" }
const _hoisted_98 = /*#__PURE__*/_createVNode("p", null, "Please select the income range and click the button to generate your E-Cheque.", -1)
const _hoisted_99 = { class: "col-md-4" }
const _hoisted_100 = /*#__PURE__*/_createVNode("option", { value: "0" }, "Income This Week", -1)
const _hoisted_101 = /*#__PURE__*/_createVNode("option", { value: "1" }, "Income This Month", -1)
const _hoisted_102 = /*#__PURE__*/_createVNode("option", { value: "2" }, "Income This Year", -1)
const _hoisted_103 = /*#__PURE__*/_createVNode("option", { value: "3" }, "Select Date Range", -1)
const _hoisted_104 = {
  key: 0,
  class: "col-md-2 fv-row"
}
const _hoisted_105 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_106 = /*#__PURE__*/_createVNode("label", { class: "fs-6 fw-bold form-label mb-2" }, "From Date", -1)
const _hoisted_107 = { class: "position-relative" }
const _hoisted_108 = {
  key: 1,
  class: "col-md-2 fv-row"
}
const _hoisted_109 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_110 = /*#__PURE__*/_createVNode("label", { class: "fs-6 fw-bold form-label mb-2" }, "To Date", -1)
const _hoisted_111 = { class: "position-relative" }
const _hoisted_112 = { class: "col-md-4 mt-8" }
const _hoisted_113 = {
  type: "button",
  id: "kt_generate_echeque_button",
  class: "btn btn-primary"
}
const _hoisted_114 = { key: 1 }
const _hoisted_115 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_116 = /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_117 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_118 = /*#__PURE__*/_createVNode("span", { class: "indicator-label" }, " Show E-Cheque Image ", -1)
const _hoisted_119 = /*#__PURE__*/_createVNode("span", { class: "indicator-label" }, " Hide E-Cheque Image ", -1)
const _hoisted_120 = /*#__PURE__*/_createVNode("div", { class: "col-md-4" }, null, -1)
const _hoisted_121 = /*#__PURE__*/_createVNode("div", { class: "col-md-6" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_Form = _resolveComponent("Form")
  const _component_Field = _resolveComponent("Field")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_Form, {
          id: "kt_account_avatar_form",
          class: "form",
          novalidate: "novalidate"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("div", {
                      class: "image-input-wrapper w-125px h-125px",
                      style: `background-image: url(${_ctx.avatarlink})`
                    }, null, 4),
                    _createVNode("label", _hoisted_10, [
                      _hoisted_11,
                      _createVNode("input", {
                        type: "file",
                        id: "avatar",
                        ref: "avatar",
                        accept: ".png, .jpg, .jpeg",
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleFileUpload()))
                      }, null, 544),
                      _hoisted_12
                    ]),
                    _createVNode("span", {
                      class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
                      "data-kt-image-input-action": "remove",
                      "data-bs-toggle": "tooltip",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeImage())),
                      title: "Remove avatar"
                    }, [
                      _hoisted_13
                    ])
                  ]),
                  _hoisted_14
                ])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, !_ctx.loading]
    ]),
    _createVNode("div", _hoisted_15, [
      _hoisted_16,
      _createVNode("div", _hoisted_17, [
        _createVNode(_component_Form, {
          id: "kt_account_profile_details_form",
          class: "form",
          novalidate: "novalidate"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _createVNode("div", _hoisted_23, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "fname",
                        class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                        placeholder: "First name",
                        modelValue: _ctx.fname,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.fname = $event)),
                        readonly: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode("div", _hoisted_24, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "mname",
                        class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                        placeholder: "Middle name",
                        modelValue: _ctx.mname,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.mname = $event)),
                        readonly: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode("div", _hoisted_25, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "lname",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: "Last name",
                        modelValue: _ctx.lname,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.lname = $event)),
                        readonly: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_26, [
                _hoisted_27,
                _createVNode("div", _hoisted_28, [
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "gender",
                    class: "form-select form-select-solid form-select-lg fw-bold",
                    modelValue: _ctx.gender,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.gender = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_29,
                      _hoisted_30
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_31, [
                _hoisted_32,
                _createVNode("div", _hoisted_33, [
                  _createVNode(_component_Field, {
                    type: "tel",
                    name: "birthday",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "Birthday",
                    modelValue: _ctx.birthday,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.birthday = $event)),
                    readonly: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_34, [
                (_ctx.ccode != 12)
                  ? (_openBlock(), _createBlock("label", _hoisted_35, "TIN/CNIC"))
                  : _createCommentVNode("", true),
                (_ctx.ccode == 12)
                  ? (_openBlock(), _createBlock("label", _hoisted_36, "KRA Number"))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_37, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "tin",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "TIN / CNIC / KRA Number",
                    modelValue: _ctx.tin,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.tin = $event)),
                    readonly: _ctx.ccode == 12 ? false : (_ctx.tinValue != '' ? true : false),
                    maxlength: _ctx.ccode == 12 ? 11 : 50
                  }, null, 8, ["modelValue", "readonly", "maxlength"])
                ])
              ]),
              _createVNode("div", _hoisted_38, [
                _hoisted_39,
                _createVNode("div", _hoisted_40, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "address",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "Address",
                    modelValue: _ctx.address,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.address = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_41, [
                _hoisted_42,
                _createVNode("div", _hoisted_43, [
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "country",
                    class: "form-select form-select-solid form-select-lg fw-bold",
                    modelValue: _ctx.selected_country,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.selected_country = $event)),
                    onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.getRegionState(_ctx.selected_country)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_44,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.countries, (item, index) => {
                        return (_openBlock(), _createBlock("option", {
                          key: index,
                          value: item.country_id
                        }, _toDisplayString(item.name), 9, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_45, [
                _hoisted_46,
                _createVNode("div", _hoisted_47, [
                  _withDirectives(_createVNode("select", {
                    name: "zone",
                    id: "zone",
                    class: "form-select form-select-solid form-select-lg fw-bold",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.selected_zone = $event)),
                    onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.checkIfNigeria($event)))
                  }, [
                    _hoisted_48,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.zones, (item, index) => {
                      return (_openBlock(), _createBlock("option", {
                        key: index,
                        value: item.zone_id
                      }, _toDisplayString(item.name), 9, ["value"]))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.selected_zone]
                  ])
                ])
              ]),
              (_ctx.selected_country == 156)
                ? (_openBlock(), _createBlock("div", _hoisted_49, [
                    _hoisted_50,
                    (_ctx.loadingLGA == false)
                      ? (_openBlock(), _createBlock("div", _hoisted_51, [
                          _withDirectives(_createVNode("select", {
                            name: "city",
                            class: "form-select form-select-solid form-select-lg fw-bold",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.selected_city = $event))
                          }, [
                            _hoisted_52,
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cities, (item, index) => {
                              return (_openBlock(), _createBlock("option", {
                                key: index,
                                value: item.lganame
                              }, _toDisplayString(item.lganame), 9, ["value"]))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.selected_city]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.loadingLGA == true)
                      ? (_openBlock(), _createBlock("div", _hoisted_53, [
                          _createVNode(_component_el_skeleton, {
                            rows: 0,
                            animated: ""
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_54, [
                _hoisted_55,
                _createVNode("div", _hoisted_56, [
                  _createVNode("div", _hoisted_57, [
                    _createVNode("div", _hoisted_58, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "mobile",
                        class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                        placeholder: "Mobile Number",
                        modelValue: _ctx.mobile,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.mobile = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_59, [
                _hoisted_60,
                _createVNode("div", _hoisted_61, [
                  _createVNode("div", _hoisted_62, [
                    _createVNode("div", _hoisted_63, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "email",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: "Email Address",
                        modelValue: _ctx.email,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.email = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              (_ctx.isBiboOnly == 'false')
                ? (_openBlock(), _createBlock("div", _hoisted_64, [
                    _hoisted_65,
                    _createVNode("div", _hoisted_66, [
                      _createVNode("div", _hoisted_67, [
                        _createVNode("input", {
                          class: "form-check-input w-45px h-30px",
                          type: "checkbox",
                          id: "btnHideUnhideNetworkActivity",
                          checked: _ctx.isHiddenNetworkActivity,
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.toggleHideNetworkActivity()))
                        }, null, 8, ["checked"]),
                        _hoisted_68
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_69, [
              _createVNode("button", {
                type: "button",
                id: "kt_account_profile_details_submit",
                class: "btn btn-primary",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.saveProfileDetails()))
              }, [
                _hoisted_70,
                _hoisted_71
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("div", _hoisted_72, [
      _hoisted_73,
      _createVNode("div", _hoisted_74, [
        _createVNode("div", _hoisted_75, [
          _createVNode("div", _hoisted_76, [
            _createVNode("div", {
              id: "kt_signin_password",
              class: { 'd-none': _ctx.passwordFormDisplay }
            }, [
              _hoisted_77,
              _hoisted_78
            ], 2),
            _createVNode("div", {
              id: "kt_signin_password_edit",
              class: ["flex-row-fluid", { 'd-none': !_ctx.passwordFormDisplay }]
            }, [
              _hoisted_79,
              _createVNode(_component_Form, {
                id: "kt_signin_change_password",
                class: "form",
                novalidate: "novalidate"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_80, [
                    _createVNode("div", _hoisted_81, [
                      _createVNode("div", _hoisted_82, [
                        _hoisted_83,
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                          name: "currentpassword",
                          id: "currentpassword",
                          modelValue: _ctx.oldpass,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.oldpass = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_84, [
                      _createVNode("div", _hoisted_85, [
                        _hoisted_86,
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                          name: "newpassword",
                          id: "newpassword",
                          modelValue: _ctx.newpass,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.newpass = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_87, [
                      _createVNode("div", _hoisted_88, [
                        _hoisted_89,
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                          name: "confirmpassword",
                          id: "confirmpassword",
                          modelValue: _ctx.confirmpass,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.confirmpass = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_90, [
                    _createVNode("button", {
                      id: "kt_password_submit",
                      type: "",
                      class: "btn btn-primary  me-2 px-6",
                      onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.changePassword()))
                    }, [
                      _hoisted_91,
                      _hoisted_92
                    ]),
                    _createVNode("button", {
                      id: "kt_password_cancel",
                      type: "button",
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.passwordFormDisplay = !_ctx.passwordFormDisplay)),
                      class: "btn btn-color-gray-400 btn-active-light-primary px-6"
                    }, " Cancel ")
                  ])
                ]),
                _: 1
              })
            ], 2),
            _createVNode("div", {
              id: "kt_signin_password_button",
              class: ["ms-auto", { 'd-none': _ctx.passwordFormDisplay }]
            }, [
              _createVNode("button", {
                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.passwordFormDisplay = !_ctx.passwordFormDisplay)),
                class: "btn btn-light fw-boldest"
              }, " Reset Password ")
            ], 2)
          ])
        ])
      ])
    ]),
    (_ctx.showGenerateECheque && _ctx.isBiboOnly == 'false')
      ? (_openBlock(), _createBlock("div", _hoisted_93, [
          _hoisted_94,
          _createVNode("div", _hoisted_95, [
            _createVNode("div", _hoisted_96, [
              _createVNode("div", _hoisted_97, [
                _hoisted_98,
                _createVNode("div", _hoisted_99, [
                  _withDirectives(_createVNode("select", {
                    class: "form-select form-select-solid mt-8",
                    id: "destination",
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.genType = $event))
                  }, [
                    _hoisted_100,
                    _hoisted_101,
                    _hoisted_102,
                    _hoisted_103
                  ], 512), [
                    [_vModelSelect, _ctx.genType]
                  ])
                ]),
                (_ctx.genType == 3)
                  ? (_openBlock(), _createBlock("div", _hoisted_104, [
                      _createVNode("div", _hoisted_105, [
                        _hoisted_106,
                        _createVNode("div", _hoisted_107, [
                          _withDirectives(_createVNode("input", {
                            type: "date",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            format: "DD/MM/yyyy",
                            name: "from_date",
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.from_date = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.from_date]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.genType == 3)
                  ? (_openBlock(), _createBlock("div", _hoisted_108, [
                      _createVNode("div", _hoisted_109, [
                        _hoisted_110,
                        _createVNode("div", _hoisted_111, [
                          _withDirectives(_createVNode("input", {
                            type: "date",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            format: "DD/MM/yyyy",
                            name: "to_date",
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.to_date = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.to_date]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_112, [
                  _createVNode("button", _hoisted_113, [
                    (!_ctx.isgeneratingCheque)
                      ? (_openBlock(), _createBlock("span", {
                          key: 0,
                          class: "indicator-label",
                          onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.generateECheque()))
                        }, " Generate "))
                      : _createCommentVNode("", true),
                    (_ctx.isgeneratingCheque)
                      ? (_openBlock(), _createBlock("span", _hoisted_114, [
                          _hoisted_115,
                          _hoisted_116
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_117,
                  _withDirectives(_createVNode("button", {
                    type: "button",
                    id: "kt_generate_echeque_button",
                    class: "btn btn-success",
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.showEChequeImageToggle()))
                  }, [
                    _hoisted_118
                  ], 512), [
                    [_vShow, !_ctx.showEChequeImage]
                  ]),
                  _withDirectives(_createVNode("button", {
                    type: "button",
                    id: "kt_generate_echeque_button",
                    class: "btn btn-warning",
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.showEChequeImageToggle()))
                  }, [
                    _hoisted_119
                  ], 512), [
                    [_vShow, _ctx.showEChequeImage]
                  ])
                ]),
                _hoisted_120
              ]),
              _hoisted_121
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}